let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5D9Of")).then(() => parcelRequire('4EO5i'));